export default function getCircleColors(CIRCLE_COLORS: number[], isbtw: boolean, quasimodoMode: boolean) {
  const pinkColor = !quasimodoMode ? CIRCLE_COLORS[1] : 0x000000;
  const colors = [CIRCLE_COLORS[0], pinkColor, CIRCLE_COLORS[2]];

  return isbtw ? [colors[1], colors[0], colors[2]] : colors;

}